angular.module('leanlaw').controller('MatterTagBillablesSidebarCtrl', ['$scope', '$rootScope', '$q', '$filter', '$stateParams', '$state', "alerts", function ($scope, $rootScope, $q, $filter, $stateParams, $state, alerts) {
  $scope.filter = {
    include: {}
  };

  // Fires immediately on filter creation
  $scope.$watch("filter", (newValue, oldValue) => {
    $rootScope.$broadcast("report-sidebar-filterchange", $scope.filter);
  }, true);
}]);